import Image from 'next/image';
import React from 'react';

import { cn } from '../../helpers/cn';

export enum KinofestBannerItemSize {
    thin,
    default
}

export default function KinofetBannerItem({
    className,
    classNameBackground,
    classNameLeadingImage,
    size,
    backgroundImage,
    trailingImage
}: {
    className?: string;
    classNameBackground?: string;
    classNameLeadingImage?: string;
    size?: KinofestBannerItemSize;
    backgroundImage: string;
    trailingImage: string;
}) {
    let classNameSize = 'h-[120px] lg:h-[240px]',
        classNamePadding = 'p-[8px] lg:p-[16px]';
    switch (size) {
        case KinofestBannerItemSize.thin:
            classNameSize = 'min-h-[140px] max-h-[140px]';
            classNamePadding = 'p-[4px] lg:p-[8px]';
            break;
    }
    return (
        <div
            className={cn(
                className,
                classNameSize,
                classNameBackground ?? 'bg-[#000000]',
                'flex w-full select-none pointer-events-none',
                'rounded-8 overflow-hidden'
            )}>
            {backgroundImage && (
                <Image
                    className={cn(classNameLeadingImage, 'h-auto object-cover', trailingImage ? 'w-1/2' : 'w-full')}
                    src={backgroundImage}
                    width={800}
                    height={600}
                    alt={'Kinofest'}
                />
            )}
            {trailingImage && (
                <Image
                    className={cn('h-auto object-contain', backgroundImage ? 'w-1/2' : 'w-full', classNamePadding)}
                    src={trailingImage}
                    width={800}
                    height={600}
                    alt={'Kinofest'}
                />
            )}
        </div>
    );
}
